import moment from 'moment';

export default {
  options: {
    hasMergeCell: true,
    groupTitles: [
      '',
      'STATUS',
      '피부관리일',
      '고객명',
      'CHART_NO',
      'FACIALISTS',
      '_DOCTORS',
      '_COUNSELORS',
      '메모',
    ],
    explodeColumn: 'items',
  },
  keys: [
    {
      title: 'STATUS',
      noorder: true,
      filter: () => {
        return `<div class="text-center">
                <span class="text-underline c-red">삭제</span>
            </div>`;
      },
    },
    {
      title: '피부관리일',
      column: 'scheduledAt',
      type: 'date',
      nosearch: true,
    },
    {
      title: 'START_AT',
      hideColumn: true,
      selectType: 'date',
      customParamFieldName: 'startAt',
      column: 'startAt',
      filter: (o) => {
        return `<div>
                <div>${moment(o.scheduledAt).format('YYYY-MM-DD')} ${
          o.startHour
        }</div>
            </div>`;
      },
    },
    {
      title: 'END_AT',
      column: 'endAt',
      hideColumn: true,
      selectType: 'date',
      customParamFieldName: 'endAt',
      filter: (o) => {
        return `<div>
                <div>${moment(o.scheduledAt).format('YYYY-MM-DD')} ${
          o.endHour
        }</div>
            </div>`;
      },
    },
    {
      title: '고객명',
      column: 'customer__name',
      noorder: true,
      customParamFieldName: 'name',
      filter: (o) =>
        `<span class="text-underline c-primary">${
          o.customer && o.customer.name
        }</span>`,
    },
    {
      title: 'CHART_NO',
      column: 'customer__chartNo',
      noorder: true,
      customParamFieldName: 'chartNo',
    },
    {
      title: 'FACIALISTS',
      column: 'facialist__name',
      noorder: true,
      customParamFieldName: 'facialistId',
    },
    {
      title: '_DOCTORS',
      column: 'doctor__name',
      noorder: true,
      customParamFieldName: 'doctorId',
    },
    {
      title: '_COUNSELORS',
      column: 'counselor__name',
      noorder: true,
      customParamFieldName: 'counselorId',
    },
    {
      title: 'SURGERY_CATEGORIES',
      column: '@@items__categoryName',
      type: 'list_mini',
      noorder: true,
      customParamFieldName: 'treatmentCategoryId',
      filter: (o) => {
        return `<div style="position: relative; width: 125px; text-align: center;">
            <div class="flex-wrap"
                style="max-width: 125px; white-space: break-spaces; display: inline-block;">${
                  o['@@items']['categoryName'] || ''
                }</div></div>`;
      },
    },
    {
      title: 'SURGERY_ITEM_NAMES',
      column: '@@items__name',
      noorder: true,
      type: 'list',
      customParamFieldName: 'treatmentItemId',
      filter: (o) => {
        return `<div style="position: relative; width: 240px; text-align: center;">
            <div class="flex-wrap"
                style="max-width: 240px; white-space: break-spaces; display: inline-block;">${
                  o['@@items']['name'] || ''
                }${
          o['@@items']['isFree']
            ? '<div class="flex-wrap ico-service"></div>'
            : ''
        }</div>
            </div>`;
      },
    },
    {
      title: '시/수술횟수',
      column: '@@items__treatmentCount',
      noorder: true,
      nosearch: true,
      filter: (o) => `<div>
            ${
              o['@@items']['treatmentCount'] === null
                ? ''
                : `${o['@@items']['treatmentCount']}회`
            }
        </div>`,
    },
    {
      title: '진행한 회차',
      column: '@@items__useCount',
      noorder: true,
      nosearch: true,
      filter: (o) => `<div>
            ${
              o['@@items']['useCount'] === null
                ? ''
                : `${o['@@items']['useCount']}회`
            }
        </div>`,
    },
    {
      title: '남은 회차',
      column: '@@items__remainingCount',
      noorder: true,
      nosearch: true,
      filter: (o) => `<div>
            ${
              o['@@items']['remainingCount'] === null
                ? ''
                : `${o['@@items']['remainingCount']}회`
            }
        </div>`,
    },
    {
      title: '메모',
      column: 'memo',
      type: 'text',
      noorder: true,
      nosearch: true,
    },
    // {
    //     title: 'UPDATE_AT',
    //     column: 'updatedAt',
    //     filter: o => {
    //         return `<div>
    //             <div>${moment(o.updatedAt).format('YYYY-MM-DD')}</div>
    //             <div>${moment(o.updatedAt).format('HH:mm:ss')}</div>
    //         </div>`
    //     },
    //     nosearch: true,
    // }
  ],
};
